import locale from "@bonliva-crm/locale";
import { QualityCheckButton } from "../quality-check-button";
import { QualityCheck, QualityCheckProps } from "../quality-check";
import { useRequestSent } from "@consultants/consultant-profile-new/quality-checks/components/quality-check/use-request-sent";
import {
  ConsultantEventLog_GetEvents,
  ConsultantQuality_GetConsultantNew,
  ConsultantQualityItemEditor_SetOrdered
} from "@graphql";

export function HprQualityCheck(props: QualityCheckProps) {
  const isHPR = props.data.Name === "HPR-nummer";

  if (!isHPR) {
    throw new Error("Wrong component");
  }

  const { data, consultantData } = props;

  const { onRequestSent, loading } = useRequestSent({
    data,
    consultantData,
    requestFn: (todo) =>
      ConsultantQualityItemEditor_SetOrdered.func(
        {
          consultantId: consultantData._id,
          country: data.Country,
          qualityCheckName: data.Name,
          setOn: new Date(),
          todo
        },
        {
          refetchQueries: [
            ConsultantEventLog_GetEvents.OperationName,
            ConsultantQuality_GetConsultantNew.OperationName
          ]
        }
      )
  });

  return (
    <QualityCheck
      renderExtraAction={() => (
        <QualityCheckButton
          text={locale.Order}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onRequestSent();
          }}
          disabled={loading || props.data.Disabled}
          loading={loading}
        />
      )}
      {...props}
    />
  );
}
